export default "__VITE_ASSET__25b35a5d__"